import { render } from "./CustomFieldsSection.vue?vue&type=template&id=62389252&scoped=true"
import script from "./CustomFieldsSection.vue?vue&type=script&lang=js"
export * from "./CustomFieldsSection.vue?vue&type=script&lang=js"

import "./CustomFieldsSection.vue?vue&type=style&index=0&id=62389252&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-62389252"]])

export default __exports__